// Test-only schedule config for Cypress e2e tests
// This file should only be used during Cypress test runs via webpack aliasing
// Matches fixtures/electronic-entries/mixed-draws-response.json
// Active during test time: Oct 31, 2025

const promoDrawsScheduleConfig = {
  "TRIPLE-BARREL-BLAST-TEST": {
    key: "tripleBarrelCashBlast2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "3608E0B6-E981-4E59-9659-4F13B762D6F7",
        labelKey: "silver"
      },
      {
        promotionId: "C1DB36E9-23F7-4A5A-B1AE-60BAD9F80EC4",
        labelKey: "gold"
      },
      {
        promotionId: "5F6E41FB-A59F-4131-BD23-A6DB02090AAD",
        labelKey: "diamond"
      }
    ],
    publish_at: "2025-10-01T00:00:00",
    earning_start: "2025-10-21T00:00:00",
    earning_end: "2025-11-02T00:00:00",
    draw_end: "2025-11-02T23:59:59",
    unpublish_at: "2025-11-03T01:00:00"
  },
  "448": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2025-09-30T00:00:00",
    earning_start: "2025-09-30T20:00:00",
    earning_end: "2025-10-29T19:00:00",
    draw_end: "2025-10-29T20:30:00",
    unpublish_at: "2025-11-01T00:00:00"
  },
  "450": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2025-09-30T00:00:00",
    earning_start: "2025-09-30T20:00:00",
    earning_end: "2025-10-29T19:00:00",
    draw_end: "2025-10-29T20:30:00",
    unpublish_at: "2025-11-01T00:00:00"
  }
};

export default promoDrawsScheduleConfig;
